import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import LTRCommonActionPanel from '../../shared/domains/LTRCommonActionPanel'

import QuickAddAccount from './QuickAddAccount';

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';

import {AccountType} from '../../../Enums';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  }
}));

const AccountActionPanel = (props) => {
  const classes = useStyles();

  const [accountType, setAccountType] = useState('');
  const [quickAddOpen, setQuickAddOpen] = useState(false);

  const handleAddBankChecking = () => {
    setAccountType(AccountType.Checking);
    setQuickAddOpen (true);
  }

  const handleAddBankSavings = () => {
    setAccountType(AccountType.Savings);
    setQuickAddOpen (true);
  }
  
  const handleAddCreditCard = () => {
    setAccountType(AccountType.Credit);
    setQuickAddOpen (true);
  }
  
  const handleAddInvestmentAccount = () => {
    setAccountType(AccountType.Investment);
    setQuickAddOpen (true);
  }
  
  const handleAddRetirementAccount= () => {
    setAccountType(AccountType.Retirement);
    setQuickAddOpen (true);
  }

  const handleAddMoneyMarket = () => {
    setAccountType(AccountType.MoneyMarket);
    setQuickAddOpen (true);
  }

  const handleAddTreasuryAccount = () => {
    setAccountType(AccountType.Treasury);
    setQuickAddOpen (true);
  }

  const handleCloseQuickAddOpen = () => {
    setQuickAddOpen(false);
  }

  const handleSave  = (account) => {
    props.handleAddNotification(account);
  }

  const handleReceiveData = (data) => {
    if (props.handleReceiveData) {
      props.handleReceiveData(data);
    }
  }

  return (
    <div className={classes.root}>
      <LTRCommonActionPanel
        actionComponents = {
          <ButtonGroup
            orientation="vertical"
            size = "small"
            color="primary"
            variant="text"
            aria-label="vertical outlined primary button group"
            >
            <Button className={classes.button} onClick={handleAddBankChecking} color="primary">
              Add a checking account
            </Button>
            <Button className={classes.button} onClick={handleAddBankSavings} color="primary">
              Add a savings account
            </Button>
            <Button className={classes.button} onClick={handleAddMoneyMarket} color="primary">
              Add a money market account
            </Button>
            <Button className={classes.button} onClick={handleAddCreditCard} color="primary">
              Add a credit card
            </Button>
            <Button className={classes.button} onClick={handleAddInvestmentAccount} color="primary">
              Add an investment account
            </Button>
            <Button className={classes.button} onClick={handleAddRetirementAccount} color="primary">
              Add a retirement account
            </Button>
            <Button className={classes.button} onClick={handleAddTreasuryAccount} color="primary">
              Add a Treasury Direct account
            </Button>
          </ButtonGroup>
        }
        />
        {quickAddOpen ? (
           <QuickAddAccount 
              open = {quickAddOpen}
              accountType= {accountType}
              handleClose = {handleCloseQuickAddOpen}
              handleSave = {handleSave}
              handleReceiveData = {handleReceiveData}
           />) 
          : null
        }
    
    </div>
  )
}

AccountActionPanel.propTypes = {
  handleAddNotification: PropTypes.func.isRequired,
  handleReceiveData: PropTypes.func.isRequired,
}

export default (AccountActionPanel)